import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Mixpanel } from 'helpers/Mixpanel';
import './ScheduleSearchFilterComponent.scss';

class SelectGroupPopover extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isShowingGroupList: false,
      selectedGroup: null,
    };
  }

  toggleGroupList = () => {
    this.setState(prev => ({ isShowingGroupList: !prev.isShowingGroupList }));
  };

  groupSelected = (group) => {
    this.setState({ selectedGroup: group, isShowingGroupList: false });
  };

  handleDoneClick = () => {
    const { handleGroupSelect } = this.props;
    const { selectedGroup } = this.state;
    handleGroupSelect(selectedGroup);
    Mixpanel.track('Confirm Group To Filter');
  };

  handleClearAllClick = () => {
    this.setState({ selectedGroup: null, isShowingGroupList: false });
    Mixpanel.track('Tap Group Clear All');
  };

  render() {
    const { groups, dropdownPos } = this.props;
    const { isShowingGroupList, selectedGroup } = this.state;

    const isText = (<FormattedMessage id="SearchFilter.is" defaultMessage="is" />);
    const clearAllText = (<FormattedMessage id="SearchFilter.clearAll" defaultMessage="Clear all" />);
    const doneText = (<FormattedMessage id="SearchFilter.done" defaultMessage="Done" />);
    const manageableGroups = groups.filter((item) => item.final_allow_manage == true);
    const groupList = manageableGroups.map(group => (
      <li key={group.id} onClick={() => this.groupSelected(group)}>
        <span>{group.channel_name} ({group.member_count})</span>
      </li>
    ));

    return (
      <div className="select-department-popover" style={{ position: 'absolute', top: dropdownPos.top, left: dropdownPos.left }}>
        <div className="flex-row top-row">
          <label>{isText}</label>
          <button className="clear-all-btn" onClick={this.handleClearAllClick}>{clearAllText}</button>
        </div>

        <button className={isShowingGroupList ? 'department-button arrow-up' : 'department-button arrow-down'} onClick={this.toggleGroupList}>
          {selectedGroup?.channel_name || ''}
        </button>

        <div className={isShowingGroupList ? 'department-dropdown shown' : 'department-dropdown not-shown'}>
          <ul>{groupList}</ul>
        </div>

        <button className="done-button" onClick={this.handleDoneClick}>{doneText}</button>
      </div>
    );
  }
}

export default injectIntl(SelectGroupPopover);
